export { SectionHeading, SectionSubHeading, SectionSubSubHeading, default } from "./ContentHeading";